import type { AccommodationDayCellVariant } from 'components/AccommodationKit/AccommodationCalendar/AccommodationCalendarLargeDayCell'
import { diffInDays } from 'lib/datetime/dateUtils'

export function getAlternativeDateOccupancyRooms(rooms: Array<App.Occupants>): Array<App.Occupants> {
  return rooms.map(({ adults, children, infants, childrenAge }) => ({
    adults,
    children,
    infants,
    childrenAge,
  }))
}

export function buildAvailabilityVariantMap(
  availabilityData: Record<string, boolean> | undefined,
): Map<string, AccommodationDayCellVariant> | undefined {
  if (!availabilityData) return undefined

  return new Map(
    Object.entries(availabilityData)
      .sort(([leftDate], [rightDate]) => leftDate.localeCompare(rightDate))
      .map(([date, isAvailable]): [string, AccommodationDayCellVariant] => [
        date,
        isAvailable ? 'availability-available' : 'availability-search',
      ]),
  )
}

export function getAlternativeDatesDuration(
  startDate: string | undefined,
  endDate: string | undefined,
  fallbackDuration: number | undefined,
): number | undefined {
  if (!startDate || !endDate) return fallbackDuration

  const selectedDuration = diffInDays(new Date(startDate), new Date(endDate))

  return selectedDuration > 0 ? selectedDuration : fallbackDuration
}
